<template>
  <div class="w-full">
    <div class="prose max-w-4xl mx-auto px-6 py-16">
      <NuxtLink to="/" class="text-secondary hover:text-primary text-sm mb-6 inline-block">
        ← Back to home
      </NuxtLink>

      <h1 class="text-4xl font-bold text-primary mb-2">Updates</h1>
      <p class="text-xl text-secondary mb-12">
        Stay up to date with the latest SupaPM developments
      </p>

      <div class="not-prose space-y-6">
        <NuxtLink
          v-for="update in updates"
          :key="update.slug"
          :to="`/updates/${update.slug}`"
          class="block"
        >
          <div class="card bg-base-100 border border-base-300 shadow-sm overflow-hidden hover:border-primary/30 transition-colors">
            <div class="card-body p-0">
              <div :class="['gap-0', update.videoId ? 'grid md:grid-cols-2' : '']">
                <div v-if="update.videoId" class="aspect-video md:aspect-auto md:min-h-[200px] bg-base-200">
                  <iframe
                    :src="`https://www.youtube.com/embed/${update.videoId}`"
                    :title="`${update.title} - video`"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    class="w-full h-full min-h-[200px]"
                  />
                </div>
                <div class="p-6 flex flex-col justify-center">
                  <div class="mb-2 flex flex-wrap items-center gap-2">
                    <span class="badge badge-primary badge-sm w-fit">{{ update.version }}</span>
                    <span class="text-xs font-medium text-secondary">{{ update.date }}</span>
                  </div>
                  <h2 class="text-xl font-bold text-primary mb-2">{{ update.title }}</h2>
                  <p class="text-secondary text-sm mb-4">{{ update.description }}</p>
                  <span class="btn btn-outline btn-sm w-fit">Read more</span>
                </div>
              </div>
            </div>
          </div>
        </NuxtLink>
      </div>

      <div class="mt-12">
        <UpdateSubscribeForm />
      </div>

      
    </div>
  </div>
</template>

<script setup lang="ts">
import { updates } from '@/data/updates'

useSeoMeta({
  title: 'Updates - SupaPM',
  description: 'Stay up to date with SupaPM development. Browser extension for product managers.',
  ogTitle: 'Updates - SupaPM',
  ogDescription: 'Stay up to date with SupaPM development. Browser extension for product managers.',
})
</script>
